export default __webpack_public_path__ + "static/onmydev_privacy_policy_v1.1-02f36e6ff4bb04fbe5f3669c4cc095d7.pdf";